// faqData.js

const faqData = [
    {
        id: 'rehoming',
        title: 'Pet Rehoming',
        faqs: [
            // Original Rehoming FAQs
            {
                question: 'How to rehome pets safely for free?',
                answer:
                    'Our 3-step safety process: 1) Adopter background checks 2) Meet & greet guidelines 3) Secure payment processing. Listings with video tours get 3x more qualified leads.',
                keywords: ['rehome pets free', 'ethical pet rehoming']
            },
            {
                question: 'Where can I rehome exotic pets like reptiles?',
                answer:
                    'Specialized section for reptiles, birds, and exotic animals. Include habitat requirements and dietary needs. Experienced owners search using filters like "bearded dragon" or "macaw".',
                keywords: ['sell exotic pets', 'rehome reptiles']
            },

            // New Rehoming FAQs from your list
            {
                question: 'Where can I rehome pets online for free?',
                answer:
                    'You can rehome pets online for free using the Pets Home App. Create an account, post a listing with photos and details about your pet, and connect with potential adopters in your area or worldwide.'
            },
            {
                question: 'What is the best app to rehome or sell pets?',
                answer:
                    'The Pets Home App is one of the best platforms for rehoming (or selling) pets. It offers free ad postings, live chat with interested parties, and features like photo/video uploads to create engaging listings.'
            },
            {
                question: 'How can I safely rehome my pet?',
                answer:
                    'To safely rehome your pet, use the Pets Home App. Communicate with potential adopters through the app’s secure chat feature, verify their details, and meet in a safe location for handover.'
            },
            {
                question: 'How can I rehome rabbits or small animals?',
                answer:
                    'Rehome rabbits or small animals using the Pets Home App. Create a listing with details about their breed, age, and temperament, along with care tips for potential adopters.'
            },
            {
                question: 'How do I find a new home for my pet?',
                answer:
                    'To find a new home for your pet, create a rehoming ad on the Pets Home App. Share details about your pet’s personality, health, and care requirements to connect with responsible adopters.'
            },
            {
                question: 'Can I rehome pets for free on Pets Home App?',
                answer:
                    'Yes, Pets Home App allows you to rehome pets for free. Simply create a rehoming ad with your pet’s details, and connect with interested adopters in your area or globally.'
            },
            {
                question: 'How do I list my pet for adoption?',
                answer:
                    'To list your pet for adoption, use the Pets Home App. Create an account, provide details about your pet, upload photos, and post your listing. Potential adopters can then contact you through the app.'
            },
            {
                question: 'How do I find local adopters for my pet?',
                answer:
                    'Pets Home App automatically targets local users, making it easier for you to find adopters nearby. Create a listing and connect with local pet lovers through the app.'
            },
            {
                question: 'What features does Pets Home App offer for pet rehoming?',
                answer:
                    'Pets Home App offers features like free ad postings, live chat, photo and video uploads, local targeting, and ad performance tracking to make rehoming pets easier.'
            },
            {
                question: 'Where to rehome a rabbit near me?',
                answer:
                    'Rehome your rabbit for free with the Pets Home App. Connect with local adopters who can provide a loving home for your rabbit.'
            },
            {
                question: 'Where can I take unwanted rabbits near me for free?',
                answer:
                    'The Pets Home App helps you find adopters for unwanted rabbits in your area. Create a free listing to rehome your rabbit quickly.'
            },
            {
                question: 'Is it bad to rehome a rabbit?',
                answer:
                    'Rehoming a rabbit is not bad if done responsibly. The Pets Home App makes it easy to find a safe and loving home for your rabbit.'
            },
            {
                question: 'Where can I rehome my rabbit in California?',
                answer:
                    'You can rehome your rabbit in California using the Pets Home App. Post a detailed listing and connect with rabbit adopters nearby.'
            },
            {
                question: 'Where can I sell or rehome a hamster near me?',
                answer:
                    'The Pets Home App helps you sell or rehome your hamster near you. Create a listing to find a new home for your hamster quickly and easily.'
            },
            {
                question: 'How can I rehome my dog urgently?',
                answer:
                    'Rehome your dog urgently with the Pets Home App. Post a detailed listing with photos to connect with potential adopters quickly.'
            },
            {
                question: 'Is it cruel to rehome a dog?',
                answer:
                    'Rehoming a dog is not cruel if it is done to ensure the dog finds a safe and loving home. The Pets Home App helps you make this process smooth and responsible.'
            },
            {
                question: 'What are the best pet rehoming sites?',
                answer:
                    'The Pets Home App is one of the best platforms for rehoming pets. It connects pet owners with a wide network of adopters locally and globally.'
            },
            {
                question: 'How to rehome a dog for free?',
                answer:
                    'Rehome your dog for free with the Pets Home App. Post a detailed listing and connect with local adopters in no time.'
            },
            {
                question: 'Where can I rehome a cat near me?',
                answer:
                    'Rehome your cat near you using the Pets Home App. Create a free listing with photos and details to find a loving new home for your cat.'
            },
            {
                question: 'How can I rehome a cat quickly?',
                answer:
                    'Rehome your cat quickly with the Pets Home App. Provide detailed information and photos to attract potential adopters faster.'
            },
            {
                question: 'Is rehoming a cat cruel?',
                answer:
                    'Rehoming a cat is not cruel if it ensures the cat goes to a loving and responsible home. The Pets Home App makes the process easy and safe.'
            }
        ]
    },
    {
        id: 'adoption',
        title: 'Pet Adoption',
        faqs: [
            // Original Adoption FAQ
            {
                question: 'How to adopt pets near me?',
                answer:
                    'Search by: • Location (within 50 miles) • Pet type • Age/size • Rescue/shelter tags. Meet adoptable pets at local events hosted through our app.',
                keywords: ['adopt pets near me', 'pet adoption process']
            },

            // New Adoption FAQs from your list
            {
                question: 'How can I find a dog rescue near me using the Pets Home App?',
                answer:
                    'Open the Pets Home App and enter your location to discover listings of rescue dogs and pets in need of new homes. Our platform features user-posted listings, including rescue groups and individuals rehoming their dogs.'
            },
            {
                question:
                    'Can I find Battersea Dogs Home dogs or similar rescues on the Pets Home App?',
                answer:
                    'While Pets Home primarily hosts user-generated listings, you may find dogs originating from well-known rescues like Battersea if a shelter or individual lists them. Simply search by location or rescue name to see if any are featured.'
            },
            {
                question:
                    'Where can I find a cat rescue shelter near me through the Pets Home App?',
                answer:
                    'The Pets Home App lets users list all types of pets, including cats from rescue organizations and individuals needing new homes. By searching for “cat rescue” near your location, you can browse available cats and connect with current caregivers.'
            },
            {
                question: 'How do I locate dog rescue homes near me on the Pets Home App?',
                answer:
                    'Simply enter your city or postcode on the Pets Home App to view listings of dogs available from rescues, foster homes, and individuals. Our platform connects you directly with those who need to rehome their dogs.'
            },
            {
                question: 'Can I find both dog and cat rescues near me on the Pets Home App?',
                answer:
                    'Yes! Pets Home is a versatile pet listing platform showcasing a variety of species. Search for dogs, cats, and other pets, many from rescue groups, all looking for loving families.'
            },
            {
                question:
                    'How can I adopt dog rescue puppies near me using the Pets Home App?',
                answer:
                    'Discover dog rescue puppies by searching your area for available pets. Listings often include puppies placed by rescue organizations or individuals. Review profiles and contact the lister directly through the app.'
            },
            {
                question: 'What is an animal dog rescue listing on the Pets Home App?',
                answer:
                    'It’s a profile created by a rescue group or individual who needs to rehome a dog. It includes photos, background information, and adoption details, allowing you to connect directly and arrange a forever home.'
            },
            {
                question: 'Where can I adopt cats?',
                answer:
                    'On the Pets Home App, you can find cats listed by local rescues, shelters, and individuals. Browse profiles, read each cat’s background, and contact the current caregiver directly.'
            },
            {
                question: 'How can I adopt kittens?',
                answer:
                    'The Pets Home App features listings for kittens needing new homes. Search for available kittens, learn about their personalities, and connect with the owner or rescue to arrange an adoption.'
            },
            {
                question: 'Where can I find people adopting puppies near me?',
                answer:
                    'The Pets Home App lets you search for puppies up for adoption in your local area. Use the location filter and browse through listings to find puppies looking for loving families nearby.'
            },
            {
                question: 'How do I find dog adoption near me for puppies?',
                answer:
                    'Check the Pets Home App’s listings for adoptable puppies. Each profile provides details on age, temperament, and requirements. Once you find a suitable puppy, contact the caretaker and discuss adoption steps.'
            },
            {
                question: 'Where can I adopt a dog?',
                answer:
                    'Open the Pets Home App and browse the “dogs” category. You’ll find listings from shelters, rescues, and individuals rehoming dogs. Review the profiles, read about the dog’s history, and reach out to start the adoption process.'
            }
        ]
    }
];

export default faqData;
